import { gspApi } from 'shared/api/gsp';
import { useAppSelector } from 'shared/hooks/store';

export const useUser = () =>
  useAppSelector(
    state => gspApi.endpoints.getApiAccountMe.select()(state)?.data,
  );
